// react
import React, { Fragment, useEffect } from "react";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import BundleForm from "./BundleForm";
// others
import { GAPageView, initGA } from "../../../../index";

// component
function BundleAdd() {
    // google analytics
    useEffect(() => {
        initGA();
        GAPageView();
    }, []);

    // template
    return (
        <Fragment>
            <HeaderTitle title="Pridať balíček" />
            <section className="bundles">
                <BundleForm data={[]} />
            </section>
        </Fragment>
    );
}

export default BundleAdd;
